module.exports = __webpack_public_path__ + "assets/img/11b_725_4.95d61784.jpg";